import { defineMessages } from 'react-intl'


export default defineMessages({
  back: {
    id: 'dashboard-content-layout.back',
    defaultMessage: 'Back',
  },
})
